const arrayToMap = function(array) {
    if (!array) {
        return null;
    }
    var map = {};

    for (var i = 0; i < array.length; i += 2) {
        map[array[i]] = array[i + 1]
    }

    return map;
};

const consoleLog = function(object) {
    console.log(object);
};

const getStringFromJsObject = function(object, key) {
    if (key in object) {
        return object[key];
    } else {
        return null;
    }
};


// This is complete non-sense but we have no other solution.
// See:
//   https://youtrack.jetbrains.com/issue/KTOR-539/Ability-to-use-browser-cookie-storage#focus=Comments-27-4775173.0-0
const injectCredentialsToFetchRequest = function(hosts) {
    window.originalFetch = window.fetch;
    window.fetch = function (resource, init) {
        try {
            var url = new URL(resource);
            if (url.host in hosts) {
                init = Object.assign({}, init);
                init.credentials = init.credentials !== undefined ? init.credentials : 'include';
            }
        } catch (err) {
            // nothing to do
        }
        return window.originalFetch(resource, init);
    };
};

export { arrayToMap, consoleLog, getStringFromJsObject, injectCredentialsToFetchRequest};